export default __webpack_public_path__ + "static/swiperCardBg-ff29e370cb6c0702a5d9265f1e0258a6.png";